import { render, staticRenderFns } from "./LecturesCollection.vue?vue&type=template&id=a3cae220&scoped=true&"
import script from "./LecturesCollection.vue?vue&type=script&lang=js&"
export * from "./LecturesCollection.vue?vue&type=script&lang=js&"
import style0 from "./LecturesCollection.vue?vue&type=style&index=0&id=a3cae220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3cae220",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VImg,VRow})
